import {
  CustomerForecast,
  CustomerForecastTimelineResponseData,
  CustomerForecastWithDiffLastMonth,
  GetCustomerForecastDiffLastMonthResponseAllOfResult,
  GetCustomerForecastTimelineResponseAllOfResult,
  SalesResult,
} from '@/coreInfrastructureModule/axios/generated/customerForecastManage';
import { ICustomerForecastDiffLastMonthResult } from '../domains/entities/customerForecastDiffLastMonthResult';
import { ICustomerForecastDiffLastMonthForecastData } from '../domains/entities/customerForecastDiffLastMonth';
import { IYearMonth } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { ICustomerForecastDiffLastMonthForecastDataFactory } from '../domains/factories/ICustomerForecastDiffLastMonthForecastDataFactory';
import { ICustomerForecastDiffLastMonthDataFactory } from '../domains/factories/ICustomerForecastDiffLastMonthDataFactory';
import {
  ICustomerForecastTimeline,
  IForecastForCustomerForecastTimeline,
  ISalesResultForCustomerForecastTimeline,
} from '../domains/entities/customerForecastTimeline';

/**
 * APIから取得したデータをUI用に変換する
 */
export class BulkGetCustomerForecastTimelineAdapter {
  /**
   * APIから取得したデータをUI用に変換する
   * @param responseData - APIから取得したデータ
   */
  public static adapt = (responseData: CustomerForecastTimelineResponseData): ICustomerForecastTimeline => {
    return {
      baseBusinessId: responseData.baseBusinessId,
      customerForecasts: this.adaptCustomerForecasts(responseData.customerForecasts),
      salesResults: this.adaptSalesResults(responseData.salesResults),
    };
  };

  /**
   * (客先内示) APIから取得したデータをUI用に変換する
   * @param customerForecasts - APIから取得したデータ
   */
  public static adaptCustomerForecasts = (customerForecasts: CustomerForecast[]): IForecastForCustomerForecastTimeline[] => {
    return customerForecasts.map((customerForecast) => {
      return {
        customerForecastId: customerForecast.customerForecastId,
        createdSupplierForecast: customerForecast.createdSupplierForecast,
        receivedYearMonth: {
          year: customerForecast.customerForecastReceivedYear,
          month: customerForecast.customerForecastReceivedMonth,
        },
        targetYearMonth: {
          year: customerForecast.customerForecastTargetYear,
          month: customerForecast.customerForecastTargetMonth,
        },
        amount: customerForecast.customerForecastAmount,
        updateAt: customerForecast.updateAt,
      };
    });
  };

  /**
   * (販売実績) APIから取得したデータをUI用に変換する
   * @param salesResults - APIから取得したデータ
   */
  public static adaptSalesResults = (salesResults: SalesResult[]): ISalesResultForCustomerForecastTimeline[] => {
    return salesResults.map((salesResult) => {
      return {
        salesResultId: salesResult.salesResultId,
        targetYearMonth: {
          year: salesResult.salesResultTargetYear,
          month: salesResult.salesResultTargetMonth,
        },
        amount: salesResult.salesResultAmount,
      };
    });
  };
}
